<template>
  <el-dialog
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="visible"
      append-to-body
      title="申请须知"
      width="1000px">



        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose()">取 消</el-button>
          <el-button type="primary" @click="handleSubmit()" :loading="loading">{{
              loading ? '确 定 ...' + count : '确 定'
            }}</el-button>
        </span>
  </el-dialog>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "notice",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      loading: true,
      count: 10,
      smsShow: false,
    }
  },
  mounted() {
    this.countDown()
  },
  methods: {
    countDown() {
      this.count = 10;
      this.smsShow = false;
      this.timer = setInterval(() => {
        if (this.count > 0 && this.count <= 10) {
          this.count--;
        } else {
          this.smsShow = true;
          clearInterval(this.timer);
          this.timer = null;
          this.loading = false
        }
      }, 1000);
    },
    handleClose() {
      this.updateDialog(false)
    },
    /* 更新visible */
    updateDialog(value) {
      this.$emit('update:visible', value);
    },
  }
})
</script>

<style scoped lang="less">

</style>
